<template>
  <SetBankTemplate needBackButton @updated="onUpdated" />
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import SetBankTemplate from "@/components/templates/SetBankTemplate.vue";
@Component({
  components: {
    SetBankTemplate
  }
})
export default class MypageSetBank extends Vue {
  async onUpdated() {
    await this.$bvModal.msgBoxOk("振込口座の設定が完了しました。", {
      okVariant: "success",
      centered: true
    });
    await this.$router.back();
  }
}
</script>
